import React, { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import ConsequenceReveal from '../shared/ConsequenceReveal';
import styles from './StaffRoomEngine.module.css';

const SEATS = [
  { label: 'A', x: 130, y: 180 },
  { label: 'B', x: 200, y: 135 },
  { label: 'C', x: 270, y: 120 },
  { label: 'D', x: 340, y: 135 },
  { label: 'E', x: 410, y: 180 }
];

const StaffRoomEngine = ({ gamifiedQuestion, onAnswer, accent = '#264653' }) => {
  const [selected, setSelected] = useState(null);
  const [showOutcome, setShowOutcome] = useState(false);
  const options = useMemo(() => gamifiedQuestion?.options?.slice(0, 5) || [], [gamifiedQuestion?.options]);
  const selectedOption = options.find((option) => option.label === selected);

  const choose = (label) => {
    if (selected) return;
    setSelected(label);
    window.setTimeout(() => setShowOutcome(true), 1000);
  };

  return (
    <div className={styles.engine} style={{ '--accent': accent }}>
      <div className={styles.sceneCard}>
        <p className={styles.situation}>{gamifiedQuestion?.situation}</p>
        <svg viewBox="0 0 600 300" className={styles.sceneSvg}>
          <rect x="140" y="130" width="320" height="80" rx="40" className={styles.table} />
          {SEATS.map((seat, index) => (
            <motion.g
              key={seat.label}
              onClick={() => choose(seat.label)}
              className={styles.seat}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 * index }}
            >
              <motion.circle
                cx={seat.x}
                cy={seat.y}
                r={17}
                className={`${styles.seatCircle} ${selected === seat.label ? styles.selectedSeat : ''}`}
                animate={selected ? {} : { scale: [1, 1.08, 1] }}
                transition={{ repeat: Infinity, duration: 1.4, delay: index * 0.08 }}
              />
              <text x={seat.x - 4} y={seat.y + 4} className={styles.seatLabel}>
                {seat.label}
              </text>
            </motion.g>
          ))}

          {[170, 250, 350, 430].map((x, index) => (
            <motion.g
              key={x}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.18 * index }}
            >
              <circle cx={x} cy="76" r="13" className={styles.colleagueHead} />
              <line x1={x} y1={89} x2={x} y2={110} className={styles.line} />
            </motion.g>
          ))}
        </svg>
      </div>

      <div className={styles.legend}>
        {options.map((option) => (
          <div key={option.label} className={styles.legendItem}>
            <strong>{option.label}</strong>
            <span>{option.actionText || option.text}</span>
          </div>
        ))}
      </div>

      <p className={styles.narration}>{gamifiedQuestion?.narration}</p>

      <ConsequenceReveal
        visible={showOutcome}
        tone={selected === 'D' || selected === 'E' ? 'success' : 'warning'}
        message={selectedOption?.consequence || 'Social positioning response captured.'}
        duration={1700}
        onDone={() => {
          setShowOutcome(false);
          if (selected) onAnswer(selected);
        }}
      />
    </div>
  );
};

export default StaffRoomEngine;
